import script from "./ChangelogPage.vue?vue&type=script&lang=ts&setup=true"
export * from "./ChangelogPage.vue?vue&type=script&lang=ts&setup=true"

import "./ChangelogPage.vue?vue&type=style&index=0&id=49c6ab5c&lang=scss"

const __exports__ = script;

export default __exports__
import QPage from 'quasar/src/components/page/QPage.js';
import QInnerLoading from 'quasar/src/components/inner-loading/QInnerLoading.js';
import QSpinner from 'quasar/src/components/spinner/QSpinner.js';
import QTimeline from 'quasar/src/components/timeline/QTimeline.js';
import QTimelineEntry from 'quasar/src/components/timeline/QTimelineEntry.js';
import qInstall from "../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QPage,QInnerLoading,QSpinner,QTimeline,QTimelineEntry});
